(() => {
  const init = async (root) => {
    if (root.dataset.elementReviewReady === 'true') return;
    root.dataset.elementReviewReady = 'true';

    try {
      const response = await fetch(root.dataset.elementReviewEndpoint, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(`Review summary request failed: ${response.status}`);

      const data = await response.json();
      const average = Number(data.average || 0).toFixed(1);
      const count = Number(data.count || 0);
      const label = count
        ? `${average}/5 (${count} ${count === 1 ? 'Testimonial' : 'Testimonials'})`
        : 'No testimonials yet';

      root.querySelector('[data-element-review-summary-text]').textContent = label;
      root.setAttribute('aria-label', `${average} out of 5 from ${count} customer testimonials. Read testimonials.`);
    } catch (error) {
      root.querySelector('[data-element-review-summary-text]').textContent = 'Read customer testimonials';
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-element-hero-review-summary]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
